import { ProductApi } from "../../../../../../../services/Api/Organization/types";

export const mapProductRecipes = (product?: ProductApi) => {
	if (!product) return undefined;
	if (product.type === "BASIC") return undefined;
	return product?.recipes || [];
};

export const measureTypeOptions = ["KILOGRAM", "LITER", "ITEM", "PACKAGE"];
